<article class="overview-fiche-repondant">
  <m-spinner
    v-if="isLoadingOverlayActive"
    :title="true"
    :description="true"
    :processing="true"
    :title-message="$i18next.t('modules.fiche-repondant.overview.OverviewFicheRepondant.loading_overlay.title')"
    :description-message="$i18next.t('modules.fiche-repondant.overview.OverviewFicheRepondant.loading_overlay.description')"
  />
  <div class="overview-fiche-repondant__header">
    <template v-if="localStorageToken">
      <m-button
        :skin="MButtonSkin.Secondary"
        @click="onNavigateToDossierExamenButtonClick"
      >
        {{ $i18next.t('modules.fiche-repondant.overview.OverviewFicheRepondant.button.navigate_dossier_examen.label') }}
      </m-button>
    </template>
    <m-button @click="onNavigateToSoumissionButtonClick">
      {{ $i18next.t('modules.fiche-repondant.overview.OverviewFicheRepondant.button.navigate_soumission.label') }}
    </m-button>
  </div>
  <div class="overview-fiche-repondant__cards">
    <template v-if="nombreCasSpeciauxRepondantDisponible > 0">
      <m-message :state="MMessageState.Warning">
        <template v-if="nombreCasSpeciauxRepondantDisponible > 1">
          {{ $i18next.t('modules.fiche-repondant.overview.OverviewFicheRepondant.message.available_cas_repondant_number.label_plural', { nombreCasSpeciauxRepondantDisponible }) }}
        </template>
        <template v-else>
          {{ $i18next.t('modules.fiche-repondant.overview.OverviewFicheRepondant.message.available_cas_repondant_number.label_singular', { nombreCasSpeciauxRepondantDisponible }) }}
        </template>
      </m-message>
    </template>
    <template v-if="fichesRepondant.length > 0">
      <template v-for="ficheRepondant in fichesRepondant">
        <fiche-repondant-card :fiche-repondant="ficheRepondant" />
      </template>
    </template>
    <template v-else>
      <m-message :state="MMessageState.Information">
        {{ $i18next.t('modules.fiche-repondant.overview.OverviewFicheRepondant.message.empty_list.label') }}
      </m-message>
    </template>
  </div>
  <m-toast
    :state="MToastState.Success"
    :position="MToastPosition.TopRight"
    :open="isDeleteSuccessToastOpen"
  >
    {{ $i18next.t('modules.fiche-repondant.overview.OverviewFicheRepondant.toast.delete_success.label') }}
  </m-toast>
</article>